import { ROUTES, TITLES, PROD, STAGE, DEV } from 'consts';

export const PLAN_MENU = {
  key: ROUTES.PLAN.ROOT,
  label: TITLES[ROUTES.PLAN.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.PLAN.PLACEMENTS,
      label: TITLES[ROUTES.PLAN.PLACEMENTS],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.PLAN.ENGINEERINGS,
      label: TITLES[ROUTES.PLAN.ENGINEERINGS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
